import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import { validationsList_template } from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import { speedTestCruxDomainConfigEdit_template } from "../components/templates/speedTestCruxDomainConfigEdit_template";

declare var ko: any;
declare var page: any;

export class speedTestCruxDomainConfigEdit extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected validationsList: validationsList_template;
    protected editForm: speedTestCruxDomainConfigEdit_template;

    protected getModuleName(){

        return "speedTestCruxDomainConfigEdit";
    }

    public buildContent(): Array<Element>{

        this.validationsList = new validationsList_template("validationList", this.viewModel, this);

        // create the pageSpeed form
        this.editForm = new speedTestCruxDomainConfigEdit_template("editForm", this.viewModel, this);

        return [this.editForm.build()];
    }

    public fillPage(): void{

        this.getFormData();
    }

    public getFormData(): void{

        let usrReq_url: string = '/api/speedTest/references';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON([])] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetFormData;
        this.XHRHdl.execute();
    }

    protected onGetFormData(req, obj){

        return function(){

            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                if(  req.request.status == 200  ){

                    obj.updateFilters(responseParsed);
                    obj.getEditData();
                }
            });
        }
    }

    protected getEditData(): void{

        let id = this.getVnAppZone().app.params.id || null;
        let idContentType = this.getVnAppZone().app.params.idContentType || null;

        if (id) {
            this.loadingIn(this.editForm.builtTemplate);

            let subViewModel = {
                idDomain: id,
                urlContentType: idContentType,
            };

            let usrReq_url: string = '/api/speedTest/configCrux/get/' + id + '/';
            let usrReq_params: Array<Array<string>> = [];
            usrReq_params.push(["data", ko.toJSON(subViewModel)]);

            this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

            this.XHRHdl.onReadyStateFunction = this.onDataRequestReturn;
            this.XHRHdl.execute();
        }
    }

    protected onDataRequestReturn(req, obj): Function{

        return function(){

            obj.manageResponse(req, obj, function(){

                let response = JSON.parse(req.request.response);

                obj.editForm.setId(response.pageSpeedOriginDomain.id);
                obj.editForm.setDomainName(response.pageSpeedOriginDomain.domain);
                obj.editForm.setGroup(response.group);
                obj.editForm.setType(response.pageSpeedOriginDomain.type);
                obj.loadingOut(obj.editForm.builtTemplate);
            });
        }
    }

    protected updateFilters(responseParsed: any){

        this.editForm.setDomains(responseParsed.domains);
        this.editForm.setGroups(responseParsed.groups);
        this.editForm.setTypes(responseParsed.types);
    }

    protected filterDropdownOnChange(idElement) {

    }

    protected cancel(){

        // Redirect to config list.
        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, "Domain configuration action canceled !");

        page.redirect('/speed_test/config_crux/');
    }

    protected save(): void{

        this.loadingIn(this.editForm.builtTemplate);

        let formReq_params: Array<Array<string>> = [];

        let subViewModel = this.editForm.getViewModelForRequest();

        formReq_params.push(["data", ko.toJSON(subViewModel)] );

        let XHRHdl:XMLHttpRequestHandler = new XMLHttpRequestHandler('/api/speedTest/configCrux/save', formReq_params, this);
        XHRHdl.mode                      = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction      = this.onSaveReturn;
        XHRHdl.execute();
    }

    protected onSaveReturn(req, obj): Function{

        return function(){

            obj.manageResponse(req, obj, function(){

                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, 'Domain configuration saved successfully!');

                obj.validationsList.clearMessages();

                let response = JSON.parse(req.request.response);

                let id = response.idDomain;
                let idContentType = response.idContentType;

                page.redirect('/speed_test/config_crux/');
            });
            obj.loadingOut(obj.editForm.builtTemplate);
        }
    }
}



// WEBPACK FOOTER //
// ./js/modules/speedTestCruxDomainConfigEdit.ts